import type { Element, SlateEditor } from '@udecode/plate';

import { BaseSourceCaptionPlugin } from '../SourceCaptionBasePlugin';

export const deleteSourceCaption = (editor: SlateEditor, at: Element) => {
    const type = editor.getType(BaseSourceCaptionPlugin);

    const pathBefore = editor.api.before(at);
    const entryBefore = editor.api.block({ at: pathBefore });
    if (entryBefore && entryBefore[0].type === type) {
        editor.tf.removeNodes({ at: pathBefore, match: { type } });
    }

    const pathAfter = editor.api.after(at);
    const entryAfter = editor.api.block({ at: pathAfter });
    if (entryAfter && entryAfter[0].type === type) {
        editor.tf.removeNodes({ at: pathAfter, match: { type } });
    }
};
